/* istanbul ignore file */

/* istanbul ignore file */
import { FieldProps, LinkField, useFieldHelper } from 'framework/ui/field';
import { useVacancyGroupUrl } from 'domain/recruiting/newVacancy/routing';
import React from 'react';

const PublicationLinkField = ({ label }: FieldProps) => {
  const { getValue: getName } = useFieldHelper({ source: 'name' });
  const { getValue: getId } = useFieldHelper({ source: 'id' });
  const { getSingleEntityUrl } = useVacancyGroupUrl();
  return (
    <LinkField
      label={label}
      linkText={getName()}
      value={`${getSingleEntityUrl()}/publications/${getId()}`}
      isInternal
    />
  );
};

export default PublicationLinkField;
